import { AlertTypes } from '../../constant/enum_data'

export const AlertAction = {
  SHOW_ALERT: 'SHOW_ALERT',
  SHOW_MODAL: 'SHOW_MODAL',
  showSuccessAlert: (message, action) => {
    return {
      type: AlertAction.SHOW_ALERT,
      payload: {
        message,
        action: action,
        type: AlertTypes.SUCCESS
      }
    }
  },
  showErrorAlert: (message, action) => {
    return {
      type: AlertAction.SHOW_ALERT,
      payload: {
        message,
        action: action,
        type: AlertTypes.ERROR,
      }
    }
  },
  showWarningAlert: (message, action) => {
    return {
      type: AlertAction.SHOW_ALERT,
      payload: {
        message,
        action: action,
        type: AlertTypes.WARNING,
      }
    }
  },
  showAlertModal: (heading, message, action) => {
    return {
      type: AlertAction.SHOW_MODAL,
      payload: {
        heading,
        message,
        action: action
      }
    }
  }
}
